import * as React from 'react';

import * as styles from './Carousel.css';

interface ICarouselProps {
  isRedesign?: boolean;
  children: React.ReactNode;
}

export const Carousel: React.FC<ICarouselProps> = ({ isRedesign = false, children }) => {
  return (
    <div className={styles['container']} style={{ gap: isRedesign ? '8px' : undefined }}>
      {children}
    </div>
  );
};
